export default __webpack_public_path__ + "static/media/sharjah-municipality-logo.81741f07.png";